<!--
下拉列表字段公告方法
-->
<template>
  <span>
    <Row>
      <Select :size="size" :transfer="true" :multiple="multiple"  filterable @on-change="change" v-model="value" :label="value" :placeholder="placeholder" :clearable="true">
        <Option value="空字段" v-if="kong">空字段</Option>
        <Option v-for="item in detail.data" :value="item.name">{{item.name}}</Option>
        </Select>
       <span  v-if="addbtn">
         <a  @click="form2.modal=true">点击管理《{{detail.note}}》</a>
      </span>
    </Row>

    <Modal
      v-model="modal1"
      :title="'增加/修改'+detail.note"
      @on-ok="save">
      <Form :label-width="120">
        <FormItem :label="detail.note" :required="true">
          <Input v-model="form.name" :placeholder="'输入'+detail.note"></Input>
        </FormItem>

        <FormItem label="排序" required="true">
            <InputNumber v-model="form.sort"></InputNumber>
            <p>数字越大，排序越靠前</p>
          </FormItem>
      </Form>
    </Modal>

     <Modal
       v-model="form2.modal"
       :title="'管理'+detail.note">
       <Button type="primary" @click="add">+增加{{detail.note}}</Button>

        <el-table :data="detail.data" size="small" style="width: 100%" >
          <el-table-column prop="name" label="字段名称" :show-tooltip-when-overflow="true"></el-table-column>
          <el-table-column prop="sort" label="排序" :show-tooltip-when-overflow="true"></el-table-column>
          <el-table-column prop="sort" label="操作" :show-tooltip-when-overflow="true">
            <template slot-scope="scope">
              <a @click="form=scope.row;modal1=true">编辑</a>
               <cite>|</cite>
               <a @click="remove(scope.row.id)">删除</a>
            </template>
          </el-table-column>
        </el-table>

    </Modal>

  </span>
</template>

<script>
  export default {
    props:{
      type:{
        type:Number,
      },
      value:{
        type:String,
        default:''
      },
      placeholder:{
        type:String,
        default:''
      },
      addbtn:{
        type:Boolean,
        default:false,
      },
      size:{
        type:String,
        default:'default'
      },
      multiple:{//是否支持多选
        type:Boolean,
        default:false
      },
      kong:{//是否显示空字段选项
        type:Boolean,
        default:false
      }
    },
    data(){
      return{
        // value:this.value,
        // val:this.value,
        detail:{},
        form:{
          id:0,
          type:0,
          name:''
        },
        modal1:false,
        form2:{
          modal:false,
        }
      }

    },
    methods:{
      remove(id){
        let that = this;
        this.$Modal.confirm({
          title: '删除数据',
          content: '<p>确定要删除数据吗，此操作不可恢复</p>',
          okText: '确定',
          cancelText: '取消',
          onOk(){
            this.$axios.get('/api/field/delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            })
          }
        });
      },
      toast(data){
        if(data>0){
          this.load();
          this.form =  {id:0,name:''};
          this.$Message.success('操作成功');
        }else{
          this.$Message.error('操作失败');
        }
      },
      load(){
        let that = this;
        this.$axios.get('/api/field/get?type='+this.type).then(function(rs){
          that.detail = rs.data;
        });
      },
      change(){
        this.$emit('input',this.value);
        this.$emit('on-change');
      },
      add(){
        this.form.type = this.detail.type;
        this.modal1 = true;
      },
      save(){
        let that = this;
        if(this.form.name==''){
          this.$Message.warning('请输入栏目名称');
          return;
        }
        this.$axios({url:'/api/field/save',method:"post",data:this.$qs.stringify(this.form)}).then(function(rs){
          if(rs.data>0){
            that.$Message.success('操作成功');
            that.load();
            that.value = that.form.name;
            that.$emit('input',that.value);
            that.form.name='';
          }else{
            that.$Message.error('操作失败');
          }
        })
      },
    },
    created(){
      this.load();
    },
    watch:{
      type:{
        handler(newValue, oldValue) {
          this.load();
        },
        deep: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/field/Field.vue